import logger from 'logger';

import emailPlugin from './plugins/email';
import smsPlugin from './plugins/sms';


export const twoFATypes = {
  email: 'email',
  sms: 'sms',
};

const pluginsMap = {
  [twoFATypes.email]: emailPlugin,
  [twoFATypes.sms]: smsPlugin,
};

class TwoFAService {
  enable = async(type, options = {}) => {
    const plugin = pluginsMap[type];
    if (!plugin) {
      const err = new Error(`No 2FA plugin available for type: ${type}`);
      logger.error(err);

      return null;
    }

    const response = await plugin.enable(options);
    const { data, error } = await this.validate(response);

    return { data, error };
  };

  validate = (response = {}) => {
    if (response.data?.status === 'VALIDATION_REQUIRED') {
      // TO BE IMPLEMENTED
    }

    return response;
  };
}

export default new TwoFAService();
